import type { AnalyticsTopic } from '@shared/api';

export const EMPTY_TOPICS: AnalyticsTopic[] = [];

export type TopicOption = {
  label: string;
  value: string;
};

export const buildTopicOptions = (topics: AnalyticsTopic[]): TopicOption[] =>
  topics.map((topic) => ({
    label: topic.topic,
    value: topic.topic,
  }));

export const sumTopicQuestions = (topic: AnalyticsTopic) =>
  topic.questions.reduce((acc, item) => acc + item.count, 0);

